import { Experiment, KnowledgeUnit, ExpertReview } from '../types'

function escapeCSV(val: string | null | undefined): string {
  if (val == null) return ''
  const s = String(val)
  if (s.includes(',') || s.includes('"') || s.includes('\n')) {
    return `"${s.replace(/"/g, '""')}"`
  }
  return s
}

function downloadFile(content: string, filename: string, mimeType: string) {
  const blob = new Blob([content], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const a = document.createElement('a')
  a.href = url
  a.download = filename
  a.click()
  URL.revokeObjectURL(url)
}

export function exportKUsCSV(kus: KnowledgeUnit[], filename: string) {
  const headers = [
    'id',
    'standard_id',
    'pass_id',
    'name',
    'description',
    'proposed_type',
    'type',
    'status',
    'experiment_id',
    'condition_id',
    'created_at',
  ]
  const rows = kus.map((ku) =>
    headers.map((h) => escapeCSV(String((ku as unknown as Record<string, unknown>)[h] ?? ''))).join(','),
  )
  downloadFile([headers.join(','), ...rows].join('\n'), filename, 'text/csv')
}

export function exportReviewsCSV(
  reviews: ExpertReview[],
  dimensions: { id: string; label: string }[],
  filename: string,
) {
  const baseHeaders = ['ku_id', 'experiment_id', 'reviewer_id', 'created_at']
  const dimHeaders = dimensions.map((d) => d.id)
  const allHeaders = [...baseHeaders, ...dimHeaders]

  const rows = reviews.map((r) => {
    const base = [r.ku_id, r.experiment_id, r.reviewer_id, r.created_at]
    const legacy = r.responses as unknown as Record<string, unknown>
    const dims = dimHeaders.map((dId) => escapeCSV(String(legacy[dId] ?? '')))
    return [...base, ...dims].join(',')
  })

  downloadFile([allHeaders.join(','), ...rows].join('\n'), filename, 'text/csv')
}

export function exportExperimentJSON(experiment: Experiment, filename: string) {
  downloadFile(JSON.stringify(experiment, null, 2), filename, 'application/json')
}

export function exportMetricsJSON(metrics: Record<string, unknown>, filename: string) {
  downloadFile(JSON.stringify(metrics, null, 2), filename, 'application/json')
}
